module.exports = function() {
  return new Worker(__webpack_public_path__ + "279309aa78ff904f8698.worker.js");
};